module.exports = __webpack_public_path__ + "img/dice-d6.174ca670.svg";